<template>
    <div class="bgColor">
        <case-header 
            :actIndex="actIndex" 
            :imgList="imgList" 
            :topStyle="topStyle" 
            :logo="logo"
            :productType="productType">
        </case-header>
        <!-- <case-title></case-title> 
          <case-info :casedetail="caseInfo"></case-info>
        -->
        <div class="contBox">
          <div class="contDetail">
            <div class="contTitle borderBottom">
              <h5>{{projectDetail.title}}</h5>
              <p>
              <span>发布时间:</span>     {{projectDetail.createtime}}</p>
            </div>
            <p class="contIntro">
              {{projectDetail.dir}}
            </p>
            <div v-html="projectDetail.content"></div>
          </div>
          <div class="contParams">
            <div class="paramsList borderBottom">
              <p>服务品牌</p>
              <h5>
              {{projectDetail.service_brand}}</h5>
            </div>
            <div class="paramsList borderBottom">
              <p>服务项目</p>
              <h5>
              {{projectDetail.service_items}}</h5>
            </div>
            <div class="paramsList borderBottom">
              <p>服务周期</p>
              <h5>
              {{projectDetail.service_cycle}}</h5>
            </div>
            <div class="paramsList borderBottom">
              <p>{{projectDetail.title}}</p>
              <div class="labelBox"><p v-for="(item,index) in LabelList" :key="index">{{item}}</p></div>
              <img class="projectLogo"  :src="projectDetail.qr_image" alt=" " v-if="projectDetail.qr_image"/>
            </div>
            <div class="paramsList">
              <p>官方咨询电话</p>
              <h5>
              <img class="phoneIcon" src="../../static/images/dianhua.png" alt=" "/>
              {{projectDetail.mobile}}</h5>
            </div>
          </div>
        </div>
        <div class="adviseBox">
          <p>让营销从此变得多姿多彩，现在咨询更多优惠!</p>
          <div class="btn" @click="jumpService">立即咨询</div>
        </div>
        <case-footer 
            :bottom="bottom" 
            :bottomInfo="bottomInfo"
            :bottomNews="bottomNews"
            :productType="productType">
        </case-footer>
    </div>
</template>

<script>
import CaseHeader from '@/components/pc/Header'
import CaseTitle from '@/components/pc/CaseTitle'
import CaseInfo from '@/components/pc/CaseInfo'
import CaseFooter from '@/components/pc/Footer'
export default {
    name: 'CaseDetails',
    data () {
        return {
            screenStyle: {
                width: '',
                margin: "0 auto",
            },
            actIndex: 4,
            topStyle: "",
            imgList: [],
            bottom: {},
            logo: '',
            bottomInfo: {},
            caseInfo: {},
            productType: [],
            CaseId:-1,
            bottomNews: [],
            projectDetail:{},
            LabelList:[],//转换后的标签类别
        }
    },
    components: {
        CaseHeader,
        CaseTitle,
        CaseInfo,
        CaseFooter,
    },
    watch: {
        $route () {
            this.CaseId = this.$route.params.id
            if(!this.CaseId) return
            this.getPageData()
        }
    },
    created () {
        this.CaseId = this.$route.params.id
        this.getPageData()
        this.getDetail()
    },
    mounted () {
    },
    methods: {
      //立即咨询
        jumpService() {
          this.$addConsult()
        },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        //获取详情
        getDetail(){
              //this.CaseId
            this.$http.get('https://eartisanapplets.wsandos.com/api/index/case',{id:this.CaseId}, (res) => {
                // console.log(res) 
                this.LabelList= res.data.industry_label_ids.split(",")
                this.projectDetail= res.data
            })
        },
        //旧接口
        getPageData () {
            this.$http.get('home/index/getcase',{id:this.CaseId}, (res) => { 
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background-image:url('"+this.$imgUrl +res.data.header[0].cgal.replace(/\\/g,'/')+"')"
                this.bottomInfo = res.data.contact[0]
                this.caseInfo = res.data.case
                this.productType = res.data.type
                this.bottomNews = res.data.b_news
                this.$nextTick(()=>{
                    // this.$refs.newsRef.imgSwiper()
                    // this.$refs.teamRef.imgSwiper()
                })
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.borderBottom {
  border-bottom: 1px solid #EEEEEE;
}

.bgColor {
  background-color: #F5F5F5;
}

.contBox {
  // position :absolute;
  // top:-380px;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  width: 1440px;
  margin: 24px auto 80px;
}

.contDetail {
  width: 980px;
  padding: 40px;
  background-color: #fff;
}

.contTitle {
  h5 {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 50px;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
  }
}

.contIntro {
  padding: 30px 0;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 34px;
}

.contParams {
  width: 440px;
  height: 900px;
  padding: 0 40px;
  background-color: #fff;
}

.paramsList {
  padding: 32px 0;

  p {
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 15px;
  }

  h5 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
    padding: 24px 0 0 0;
  }
}

.projectLogo {
  margin: 24px 0 0 0;
  width: 220px;
  height: 220px;
}

.phoneIcon {
  width: 20px;
  height: 20px;
  margin: 0 13px 0 0;
}

.adviseBox {
  width: 100%;
  height: 160px;
  background: linear-gradient(-90deg, #FFC000, #F5B400);
  text-align: center;

  p {
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 28px;
    padding: 31px 0 25px 0;
  }

  .btn {
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    font-size: 18px;
    width: 170px;
    padding: 16px 0;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 20px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.labelBox {
  display: flex;
  justify-content: flex-start;
  flex-wrap :wrap;

    margin :10px 0 0 0;
  >p {
    padding: 3px 5px;
    background: #F5F5F5;
    border-radius: 1px;
    font-size: 0.9px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #666666;
    line-height: 19px;
    margin :8px 8px 0 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/CaseDetail.vue